import { DraftAddEntityButton } from '../../Draft'
import { useRequestDraft, useRequestWizardDraft } from '../Request.hooks'
import { RequestDraftCreateActionSelect } from '../RequestDraftCreateActionSelect'

import RequestCreateActionButton from './RequestCreateActionButton'

function RequestAddButton({
  Button = RequestCreateActionButton,
  Select = RequestDraftCreateActionSelect,
  isWizardEnabled = false,
  ...props
}) {
  const regular = useRequestDraft()
  const wizard = useRequestWizardDraft()

  const { draft, draftId } = isWizardEnabled ? wizard : regular

  return (
    <DraftAddEntityButton
      {...props}
      Button={Button}
      Select={Select}
      draft={draft}
      draftId={draftId}
    />
  )
}

export default RequestAddButton
